import { gql } from '@apollo/client';

export const ELIGIBILITY_VALIDATION = gql`
	query eligibilityValidation(
		$crewMemberId: ID!
		$rideId: ID!
		$fromStationId: ID!
		$toStationId: ID!
		$activityType: ActivityType!
	) {
		eligibilityValidation(
			crewMemberId: $crewMemberId
			rideId: $rideId
			fromStationId: $fromStationId
			toStationId: $toStationId
			activityType: $activityType
		) {
			failedRule
			defaultMessage
		}
	}
`;

export const VALIDATE_AND_OVERLAPS = gql`
	query ValidateAndOverlaps(
		$crewMemberId: ID!
		$rideId: ID!
		$fromStationId: ID!
		$toStationId: ID!
		$activityType: ActivityType!
	) {
		eligibility: eligibilityValidation(
			crewMemberId: $crewMemberId
			rideId: $rideId
			fromStationId: $fromStationId
			toStationId: $toStationId
			activityType: $activityType
		) {
			failedRule
			defaultMessage
		}

		overlaps: overlappingCrewMemberActivitiesV2(
			crewMemberId: $crewMemberId
			rideId: $rideId
			fromStationId: $fromStationId
			toStationId: $toStationId
		) {
			overlappingActivities {
				fromTimestamp
				toTimestamp
				isCancellable
				activity {
					... on CrewMemberWorkAssignmentActivityItem {
						activityType
						fromStation {
							name
							code
							timezone
							city {
								name
							}
						}
						toStation {
							name
							code
							timezone
							city {
								name
							}
						}
					}
					... on CrewMemberAbsenceActivityItem {
						note
						reason {
							id
							name
						}
					}
				}
			}
			minDelayMinutes
			maxDelayMinutes
		}
	}
`;
